var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4248 4.76721V1.83633C4.4248 1.57723 4.52977 1.32873 4.71662 1.14552C4.90347 0.962304 5.15689 0.859375 5.42114 0.859375H17.3772C17.6414 0.859375 17.8949 0.962304 18.0817 1.14552C18.2685 1.32873 18.3735 1.57723 18.3735 1.83633V15.5138C18.3735 15.7729 18.2685 16.0214 18.0817 16.2046C17.8949 16.3878 17.6414 16.4907 17.3772 16.4907H14.3882V19.4216C14.3882 19.9609 13.9398 20.3985 13.3849 20.3985H1.44276C1.31137 20.3993 1.18112 20.3746 1.0595 20.3259C0.937868 20.2771 0.827261 20.2053 0.734029 20.1145C0.640797 20.0238 0.566778 19.9158 0.516225 19.7969C0.465672 19.678 0.439582 19.5504 0.439453 19.4216L0.442442 5.74417C0.442442 5.20489 0.890794 4.76721 1.44476 4.76721H4.4248ZM2.43412 6.72113L2.43213 18.4446H12.3955V6.72113H2.43412ZM6.41748 4.76721H14.3882V14.5368H16.3808V2.81329H6.41748V4.76721ZM4.4248 9.652H10.4028V11.6059H4.4248V9.652ZM4.4248 13.5598H10.4028V15.5138H4.4248V13.5598Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9153ee0a.svg";
export { ForwardRef as ReactComponent };